import type { GeoLocation } from '../../types/core';

/** Persists school wizard data between the profile step and plan/checkout (sessionStorage). */
export const SCHOOL_ONBOARDING_DRAFT_KEY = 'bn_school_onboarding_draft_v1';

/**
 * Snapshot after profile + avatar upload, before school entity creation.
 * School creation runs after the user picks a plan (free: immediately; paid: after billing).
 */
export interface SchoolOnboardingDraft {
  schoolForm: Record<string, any>;
  schoolLocation?: GeoLocation;
  personalForm: Record<string, any>;
  /** Older drafts / alternate writers; prefer `personalForm.firstName`. */
  personalFirstName?: string;
  /** Older drafts / alternate writers; prefer `personalForm.lastName`. */
  personalLastName?: string;
  personalLocation?: GeoLocation;
  selectedJobFunctions: {
    value: string;
    jobLevels: string[];
    jobLevelDescriptions: string[];
    /** null = not answered yet. */
    inStudy: boolean | null;
    /** null = not answered; missing in drafts saved before the question. */
    isQualified?: boolean | null;
  }[];
  avatarBase64?: string;
  currentStepIndex: number;
}

export function saveSchoolOnboardingDraft(draft: SchoolOnboardingDraft): void {
  sessionStorage.setItem(SCHOOL_ONBOARDING_DRAFT_KEY, JSON.stringify(draft));
}

export function loadSchoolOnboardingDraft(): SchoolOnboardingDraft | null {
  try {
    const raw = sessionStorage.getItem(SCHOOL_ONBOARDING_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SchoolOnboardingDraft;
  } catch {
    return null;
  }
}

export function clearSchoolOnboardingDraft(): void {
  sessionStorage.removeItem(SCHOOL_ONBOARDING_DRAFT_KEY);
}
